<template>
  <form
    class="tile filters filter-form"
    @submit.prevent="submitFilters"
    @keypress.enter.prevent="submitFilters"
  >
    <div class="flex__between heading--box">
      <span class="heading">Filters</span>
      <button class="btn btn__small" @click="resetFilters">Reset Filters</button>
    </div>
    <label for="name" class="filter-form--label">
      Name:
      <input type="text" id="name" name="name" v-model="form.name" />
    </label>
    <label for="status" class="filter-form--label">
      Status:
      <select id="status" name="status" v-model="form.status">
        <option value="any">Any</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </label>
    <label for="sort" class="filter-form--label">
      Sort Users:
      <select id="sort" name="sort" v-model="form.sort">
        <option value="a-z">A to Z</option>
        <option value="z-a">Z to A</option>
      </select>
    </label>
    <button class="btn btn--submit" @click.prevent="submitFilters">Apply Filters</button>
  </form>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      form: {
        name: "",
        status: "any",
        sort: "a-z"
      }
    };
  },
  methods: {
    ...mapActions(["startSetUserFilters"]),
    resetFilters() {
      this.form.name = "";
      this.form.status = "any";
      this.form.sort = "a-z";
      this.startSetUserFilters(this.form);
    },
    submitFilters() {
      this.startSetUserFilters(this.form);
    }
  }
};
</script>

<style scoped>
</style>